import { render, staticRenderFns } from "./LocationCard1.vue?vue&type=template&id=bde0390c&"
import script from "./LocationCard1.vue?vue&type=script&lang=js&"
export * from "./LocationCard1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports